/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamAdmissionAdmittedAt } from './examAdmissionAdmittedAt';
import type { ExamAdmissionAdmittedBy } from './examAdmissionAdmittedBy';

export interface ExamAdmission {
  admitted?: boolean;
  admittedAt?: ExamAdmissionAdmittedAt;
  admittedBy?: ExamAdmissionAdmittedBy;
}
